const MOBILE_MAX_WIDTH = 768;
const AUTO_COLLAPSE_SCROLL_Y = 200;

// class active = trạng thái THU của #float_right (lib MJ__toogleActive toggle cùng class)
const navFloat = document.querySelector('#float_right');
let autoCollapseNav = navFloat && window.innerWidth > MOBILE_MAX_WIDTH;

// để sẵn src thì mobile tải mất ~2.5MB video trước khi lib kịp xoá .MS__pc, nên chỉ gán trên PC
const headVideo = document.querySelector('#Frame1 .bg-video');
if (headVideo && window.innerWidth > MOBILE_MAX_WIDTH) headVideo.src = headVideo.dataset.src;

window.addEventListener('scroll', () => {
  if (!autoCollapseNav || window.scrollY < AUTO_COLLAPSE_SCROLL_Y) return;
  autoCollapseNav = false;
  navFloat.classList.add('active');
});

// design: dải chữ + tiêu đề vàng trên khung popup mang tên section đã mở nó, nên copy từ nút bấm sang
document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-ribbon][data-target]');
  if (!btn) return;
  const popup = document.querySelector(btn.dataset.target);
  if (!popup) return;

  const ribbon = popup.querySelector('.ribbon');
  if (ribbon) ribbon.textContent = btn.dataset.ribbon;

  const title = popup.querySelector('.popup-title');
  if (!title || !btn.dataset.popupTitle) return;
  const [line, sub = ''] = btn.dataset.popupTitle.split('|');
  title.querySelector('.popup-title-text').textContent = line;
  title.querySelector('.popup-title-sub').textContent = sub;
  title.classList.toggle('has-sub', !!sub);
});
